// Convert permission codes to user-friendly messages
export const getPermissionMessage = (permissionCode) => {
  const permissionMessages = {
    // Role Management
    'role.read': 'You do not have permission to view roles',
    'role.create': 'You do not have permission to create roles',
    'role.update': 'You do not have permission to edit roles',
    'role.delete': 'You do not have permission to delete roles',
    'role.assign': 'You do not have permission to assign roles',
    
    // User Management
    'user.read': 'You do not have permission to view users',
    'user.create': 'You do not have permission to create users',
    'user.update': 'You do not have permission to edit users',
    'user.delete': 'You do not have permission to delete users',
    
    // Client Management
    'client.read': 'You do not have permission to view clients',
    'client.create': 'You do not have permission to create clients',
    'client.update': 'You do not have permission to edit clients',
    'client.delete': 'You do not have permission to delete clients',
    
    // Patient Management
    'patient.read': 'You do not have permission to view patients',
    'patient.create': 'You do not have permission to create patients',
    'patient.update': 'You do not have permission to edit patients',
    'patient.delete': 'You do not have permission to delete patients',
    
    // Caregiver Management
    'caregiver.read': 'You do not have permission to view caregivers',
    'caregiver.create': 'You do not have permission to create caregivers',
    'caregiver.update': 'You do not have permission to edit caregivers',
    'caregiver.delete': 'You do not have permission to delete caregivers',
    
    // Audit & Reports
    'audit.read': 'You do not have permission to view audit logs',
    'audit.export': 'You do not have permission to export audit data',
    'billing.read': 'You do not have permission to view billing information',
    'billing.manage': 'You do not have permission to manage billing',
    
    // System
    'system.config': 'You do not have permission to configure system settings',
    'system.maintenance': 'You do not have permission to perform system maintenance'
  };
  
  return permissionMessages[permissionCode] || 'You do not have permission to access this feature';
};

// Extract permission from error message and convert to user-friendly message
export const getPermissionErrorMessage = (errorMessage) => {
  // Extract permission from message like "Permission 'role.read' required"
  const match = errorMessage.match(/Permission '([^']+)' required/);
  if (match && match[1]) {
    return getPermissionMessage(match[1]);
  }
  return 'You do not have permission to access this feature';
};